import {Badge} from '@cohort/merchants/components/Badge';
import type {OwnershipStatus} from '@cohort/shared/schema/common/ownerships';
import {useTranslation} from 'react-i18next';
import {match} from 'ts-pattern';

const DigitalAssetStatusBadge = ({status}: {status: OwnershipStatus}): JSX.Element => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'users.user.digitalAssets.digitalAssetStatusBadge',
  });
  return match(status)
    .with('owned', () => (
      <Badge
        text={t('owned')}
        textColor="text-primary-darker"
        dotColor="text-primary-darker"
        backgroundColor="bg-primary/10"
      />
    ))
    .with('transferred', () => (
      <Badge
        text={t('transferred')}
        textColor="text-primary"
        dotColor="text-primary"
        backgroundColor="bg-primary/10"
      />
    ))
    .with('pending_transfer', () => (
      <Badge
        text={t('pending_transfer')}
        textColor="text-orange-600"
        dotColor="text-orange-600"
        backgroundColor="bg-orange-100"
      />
    ))
    .with('transferring', () => (
      <Badge
        text={t('transferring')}
        textColor="text-orange-600"
        dotColor="text-orange-600"
        backgroundColor="bg-orange-100"
      />
    ))
    .with('transfer_failed', () => (
      <Badge
        text={t('transfer_failed')}
        textColor="text-red-600"
        dotColor="text-red-600"
        backgroundColor="bg-red-100"
      />
    ))
    .exhaustive();
};

export default DigitalAssetStatusBadge;
